import type { FirestoreDataConverter } from '~/types/firestore'
import type { SummaryDocument, ThrowSummary } from '~/types/throws'
import { generateThrowSummaryMetrics } from './throwStats'

export const throwSummaryConverter: FirestoreDataConverter<ThrowSummary, SummaryDocument> = {
    fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options)

        return fromFirestore(snapshot.id, data) as ThrowSummary
    },
    toFirestore: modelObject => {
        return toFirestore({ ...modelObject })
    },
}

const fromFirestore = (id: string, summaryDocument: SummaryDocument): ThrowSummary => {
    return {
        id,
        ...summaryDocument,
        metricsLoading: !summaryDocument.speedMph,
        metrics: generateThrowSummaryMetrics(summaryDocument),
        summaryDocument: summaryDocument,
    }
}

const toFirestore = (summary: ThrowSummary): SummaryDocument => {
    return summary.summaryDocument
}
